import { useMemo } from 'react';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { PhoneApps } from '~/shared';
import { appsIcons } from '../../models/PhoneApp';
import { wallpapers } from '../../models/Wallpaper';
import {
	StyledContainer,
	StyledNotification,
	StyledNotificationText,
} from './Notification.styled';

const Notification = () => {
	const settings = useObservable(rage.phone.getSettings());
	const notificationState = useObservable(rage.phone.getNotificationState());
	const gameTime = useMemo(() => rage.game.getGameTime().getValue(), []);

	return (
		<StyledContainer
			style={{
				backgroundImage: `url(${wallpapers[settings.wallpaperIndex]})`,
			}}
		>
			<StyledNotification>
				<img
					src={appsIcons[notificationState?.app || PhoneApps.PHONE]}
					width={40}
					height={40}
				/>
				<StyledNotificationText>
					<Text>{notificationState?.title}</Text>
					<Text>{notificationState?.message}</Text>
				</StyledNotificationText>
				<Text
					style={{
						color: '#ffffff',
						fontSize: 12,
						fontWeight: 500,
						opacity: 0.5,
					}}
				>
					{gameTime}
				</Text>
			</StyledNotification>
		</StyledContainer>
	);
};

export { Notification };
